import { VscHome, VscPreview } from "react-icons/vsc";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { FiCalendar } from "react-icons/fi";
import { IoMdBook } from "react-icons/io";
import { IoMdSchool } from "react-icons/io";
import { MdEdit } from "react-icons/md";
// import { MdPayment } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineRequestPage } from "react-icons/md";
import { BiEnvelope } from "react-icons/bi";
import { IoWalletOutline } from "react-icons/io5";

export const teacherRouteConfig = [
  {
    path: "/teacher",
    icon: VscHome,
    name: "Home",
  },
  {
    path: "/teacher/offers",
    icon: MdOutlineRequestPage,
    name: "Offers",
  },
  {
    path: "/teacher/messages",
    icon: BiEnvelope,
    name: "Messages",
  },

  {
    // path: "/teacher/courses",
    icon: IoMdBook,
    name: "My Profile",
    children: [
      {
        path: "/teacher/profile-preview",
        icon: VscPreview,
        name: "Profile Preview",
      },
      {
        path: "/teacher/courses",
        icon: IoMdBook,
        name: "Teaching Preference",
      },
      // {
      //   path: "/teacher/teaching-board",
      //   icon: MdOutlineCastForEducation,
      //   name: "Teaching Boards",
      // },

      {
        path: "/teacher/education",
        icon: IoMdSchool,
        name: "Education",
      },
      {
        path: "/teacher/documents",
        icon: IoDocumentTextOutline,
        name: "Documents",
      },
      {
        path: "/teacher/experience",
        icon: FaHandHoldingDollar,
        name: "Experience",
      },
      {
        path: "/teacher/modeOfTeaching",
        icon: MdEdit,
        name: "Mode of Teaching",
      },
      {
        path: "/teacher/slot",
        icon: FiCalendar,
        name: "Slot",
      },
    ],
  },
  // {
  //   path: "/teacher/schedule",
  //   icon: MdSchedule,
  //   name: "Schedule Meeting",
  // },

  // {
  //   path: "/teacher/payment",
  //   icon: MdPayment,
  //   name: "Payment",
  // },
  {
    path: "/teacher/settings",
    icon: FiSettings,
    name: "Profile Settings",
  },
  {
    path: "/teacher/wallet-summary",
    icon: IoWalletOutline,
    name: "Wallet",
  },
];

export const studentRouteConfig = [
  {
    path: "/student",
    icon: VscHome,
    name: "Home",
  },
  {
    path: "/student/offers",
    icon: MdOutlineRequestPage,
    name: "Offers",
  },
  {
    path: "/student/messages",
    icon: BiEnvelope,
    name: "Messages",
  },

  // {
  //   path: "/student/about",
  //   icon: BiEnvelope,
  //   name: "Messages",
  // },

  {
    path: "/student/findTeacher",
    icon: FaChalkboardTeacher,
    name: "Find Teacher",
  },

  {
    path: "/student/settings",
    icon: FiSettings,
    name: "Profile Settings",
  },
  {
    path: "/student/wallet-summary",
    icon: IoWalletOutline,
    name: "Wallet",
  },
];
